export default __webpack_public_path__ + "ddb0f4f4e88b5e35e75ca255d24c6013.svg";